var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.9999C3.46957 15.9999 2.96086 16.2107 2.58579 16.5857C2.21071 16.9608 2 17.4695 2 17.9999V19.9999H22V17.9999C22 17.4695 21.7893 16.9608 21.4142 16.5857C21.0391 16.2107 20.5304 15.9999 20 15.9999M4 15.9999H20M4 15.9999C4 13.8782 4.84285 11.8434 6.34315 10.3431C7.84344 8.84279 9.87827 7.99994 12 7.99994M20 15.9999C20 13.8782 19.1571 11.8434 17.6569 10.3431C16.1566 8.84279 14.1217 7.99994 12 7.99994M12 7.99994V3.99994M10 3.99994H14",
    stroke: "#101010",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.f7d5ce9cda2cdf33de3a54a7125ab4ac.svg";
export { ForwardRef as ReactComponent };